import type {
  WmsAdjustApiData,
  WmsAdjustApiResponses,
  WmsAllocateReservationApiData,
  WmsAllocateReservationApiResponses,
  WmsAllocationGetApiData,
  WmsAllocationGetApiResponses,
  WmsAllocationListApiData,
  WmsAllocationListApiResponses,
  WmsAvailabilityApiData,
  WmsAvailabilityApiResponses,
  WmsCycleCountCancelApiData,
  WmsCycleCountCancelApiResponses,
  WmsCycleCountCompleteApiData,
  WmsCycleCountCompleteApiResponses,
  WmsCycleCountCountLineApiData,
  WmsCycleCountCountLineApiResponses,
  WmsCycleCountCreateApiData,
  WmsCycleCountCreateApiResponses,
  WmsCycleCountGetApiData,
  WmsCycleCountGetApiResponses,
  WmsCycleCountListApiData,
  WmsCycleCountListApiResponses,
  WmsLevelEnsureApiData,
  WmsLevelEnsureApiResponses,
  WmsLevelGetApiData,
  WmsLevelGetApiResponses,
  WmsLevelListApiData,
  WmsLevelListApiResponses,
  WmsMovementListApiData,
  WmsMovementListApiResponses,
  WmsOrganizationPolicyCreateApiData,
  WmsOrganizationPolicyCreateApiResponses,
  WmsOrganizationPolicyGetApiData,
  WmsOrganizationPolicyGetApiResponses,
  WmsOrganizationPolicyListApiData,
  WmsOrganizationPolicyListApiResponses,
  WmsOrganizationPolicyPatchApiData,
  WmsOrganizationPolicyPatchApiResponses,
  WmsPositionCreateApiData,
  WmsPositionCreateApiResponses,
  WmsPositionListApiData,
  WmsPositionListApiResponses,
  WmsReceiptApiData,
  WmsReceiptApiResponses,
  WmsReleaseReservationApiData,
  WmsReleaseReservationApiResponses,
  WmsReservationGetApiData,
  WmsReservationGetApiResponses,
  WmsReservationListApiData,
  WmsReservationListApiResponses,
  WmsReserveApiData,
  WmsReserveApiResponses,
  WmsSaleAllocationApiData,
  WmsSaleAllocationApiResponses,
  WmsScanApiData,
  WmsScanApiResponses,
  WmsScrapApiData,
  WmsScrapApiResponses,
  WmsStockPolicyCreateApiData,
  WmsStockPolicyCreateApiResponses,
  WmsStockPolicyDeleteApiData,
  WmsStockPolicyDeleteApiResponses,
  WmsStockPolicyGetApiData,
  WmsStockPolicyGetApiResponses,
  WmsStockPolicyListApiData,
  WmsStockPolicyListApiResponses,
  WmsStockPolicyPatchApiData,
  WmsStockPolicyPatchApiResponses,
  WmsTransferCancelApiData,
  WmsTransferCancelApiResponses,
  WmsTransferCompleteApiData,
  WmsTransferCompleteApiResponses,
  WmsTransferCreateApiData,
  WmsTransferCreateApiResponses,
  WmsTransferDispatchApiData,
  WmsTransferDispatchApiResponses,
  WmsTransferGetApiData,
  WmsTransferGetApiResponses,
  WmsTransferListApiData,
  WmsTransferListApiResponses,
  WmsWarehouseCreateApiData,
  WmsWarehouseCreateApiResponses,
  WmsWarehouseGetApiData,
  WmsWarehouseGetApiResponses,
  WmsWarehouseIssuesApiData,
  WmsWarehouseIssuesApiResponses,
  WmsWarehouseListApiData,
  WmsWarehouseListApiResponses,
  WmsWarehousePatchApiData,
  WmsWarehousePatchApiResponses,
  WmsWarehouseSummaryApiData,
  WmsWarehouseSummaryApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getWmsUrls = {
  getPaginatedWmsWarehouses: dataEndpoint<WmsWarehouseListApiData, WmsWarehouseListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/warehouses/', queryParams)
  }),
  getWmsWarehouse: dataEndpoint<WmsWarehouseGetApiData, WmsWarehouseGetApiResponses>({
    getUrl: ({ warehouseId }) => apiUrl(`wms/warehouses/${warehouseId}/`)
  }),
  postWmsWarehouse: responseEndpoint<WmsWarehouseCreateApiData, WmsWarehouseCreateApiResponses>({
    getUrl: () => apiUrl('wms/warehouses/'),
    getBody: (data) => data
  }),
  patchWmsWarehouse: responseEndpoint<WmsWarehousePatchApiData, WmsWarehousePatchApiResponses>({
    getUrl: ({ warehouseId }) => apiUrl(`wms/warehouses/${warehouseId}/`),
    getBody: ({ warehouseId: _, ...body }) => body
  }),
  getWmsWarehouseSummary: dataEndpoint<WmsWarehouseSummaryApiData, WmsWarehouseSummaryApiResponses>({
    getUrl: ({ warehouseId }) => apiUrl(`wms/warehouses/${warehouseId}/summary/`)
  }),
  getWmsWarehouseIssues: dataEndpoint<WmsWarehouseIssuesApiData, WmsWarehouseIssuesApiResponses>({
    getUrl: ({ warehouseId, ...queryParams }) => apiUrl(`wms/warehouses/${warehouseId}/issues/`, queryParams)
  }),
  getPaginatedWmsLevels: dataEndpoint<WmsLevelListApiData, WmsLevelListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/levels/', queryParams)
  }),
  getWmsLevel: dataEndpoint<WmsLevelGetApiData, WmsLevelGetApiResponses>({
    getUrl: ({ levelId }) => apiUrl(`wms/levels/${levelId}/`)
  }),
  postWmsLevelEnsure: responseEndpoint<WmsLevelEnsureApiData, WmsLevelEnsureApiResponses>({
    getUrl: () => apiUrl('wms/levels/'),
    getBody: (data) => data
  }),
  getPaginatedWmsPositions: dataEndpoint<WmsPositionListApiData, WmsPositionListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/positions/', queryParams)
  }),
  postWmsPosition: responseEndpoint<WmsPositionCreateApiData, WmsPositionCreateApiResponses>({
    getUrl: () => apiUrl('wms/positions/'),
    getBody: (data) => data
  }),
  getPaginatedWmsMovements: dataEndpoint<WmsMovementListApiData, WmsMovementListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/movements/', queryParams)
  }),
  postWmsAdjust: responseEndpoint<WmsAdjustApiData, WmsAdjustApiResponses>({
    getUrl: () => apiUrl('wms/movements/adjust/'),
    getBody: (data) => data
  }),
  postWmsReceipt: responseEndpoint<WmsReceiptApiData, WmsReceiptApiResponses>({
    getUrl: () => apiUrl('wms/movements/receipt/'),
    getBody: (data) => data
  }),
  postWmsScrap: responseEndpoint<WmsScrapApiData, WmsScrapApiResponses>({
    getUrl: () => apiUrl('wms/movements/scrap/'),
    getBody: (data) => data
  }),
  getPaginatedWmsReservations: dataEndpoint<WmsReservationListApiData, WmsReservationListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/reservations/', queryParams)
  }),
  getWmsReservation: dataEndpoint<WmsReservationGetApiData, WmsReservationGetApiResponses>({
    getUrl: ({ reservationId }) => apiUrl(`wms/reservations/${reservationId}/`)
  }),
  postWmsReserve: responseEndpoint<WmsReserveApiData, WmsReserveApiResponses>({
    getUrl: () => apiUrl('wms/reservations/'),
    getBody: (data) => data
  }),
  postWmsReleaseReservation: responseEndpoint<WmsReleaseReservationApiData, WmsReleaseReservationApiResponses>({
    getUrl: ({ reservationId }) => apiUrl(`wms/reservations/${reservationId}/release/`)
  }),
  postWmsAllocateReservation: responseEndpoint<WmsAllocateReservationApiData, WmsAllocateReservationApiResponses>({
    getUrl: ({ reservationId }) => apiUrl(`wms/reservations/${reservationId}/allocate/`)
  }),
  getPaginatedWmsAllocations: dataEndpoint<WmsAllocationListApiData, WmsAllocationListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/allocations/', queryParams)
  }),
  getWmsAllocation: dataEndpoint<WmsAllocationGetApiData, WmsAllocationGetApiResponses>({
    getUrl: ({ allocationId }) => apiUrl(`wms/allocations/${allocationId}/`)
  }),
  postWmsSaleAllocation: responseEndpoint<WmsSaleAllocationApiData, WmsSaleAllocationApiResponses>({
    getUrl: ({ allocationId }) => apiUrl(`wms/allocations/${allocationId}/sale/`)
  }),
  postWmsAvailability: responseEndpoint<WmsAvailabilityApiData, WmsAvailabilityApiResponses>({
    getUrl: () => apiUrl('wms/availability/'),
    getBody: (data) => data
  }),
  getPaginatedWmsTransfers: dataEndpoint<WmsTransferListApiData, WmsTransferListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/transfers/', queryParams)
  }),
  getWmsTransfer: dataEndpoint<WmsTransferGetApiData, WmsTransferGetApiResponses>({
    getUrl: ({ transferId }) => apiUrl(`wms/transfers/${transferId}/`)
  }),
  postWmsTransfer: responseEndpoint<WmsTransferCreateApiData, WmsTransferCreateApiResponses>({
    getUrl: () => apiUrl('wms/transfers/'),
    getBody: (data) => data
  }),
  postWmsTransferDispatch: responseEndpoint<WmsTransferDispatchApiData, WmsTransferDispatchApiResponses>({
    getUrl: ({ transferId }) => apiUrl(`wms/transfers/${transferId}/dispatch/`)
  }),
  postWmsTransferComplete: responseEndpoint<WmsTransferCompleteApiData, WmsTransferCompleteApiResponses>({
    getUrl: ({ transferId }) => apiUrl(`wms/transfers/${transferId}/complete/`)
  }),
  postWmsTransferCancel: responseEndpoint<WmsTransferCancelApiData, WmsTransferCancelApiResponses>({
    getUrl: ({ transferId }) => apiUrl(`wms/transfers/${transferId}/cancel/`)
  }),
  getPaginatedWmsCycleCounts: dataEndpoint<WmsCycleCountListApiData, WmsCycleCountListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/cycle-counts/', queryParams)
  }),
  getWmsCycleCount: dataEndpoint<WmsCycleCountGetApiData, WmsCycleCountGetApiResponses>({
    getUrl: ({ cycleCountId }) => apiUrl(`wms/cycle-counts/${cycleCountId}/`)
  }),
  postWmsCycleCount: responseEndpoint<WmsCycleCountCreateApiData, WmsCycleCountCreateApiResponses>({
    getUrl: () => apiUrl('wms/cycle-counts/'),
    getBody: (data) => data
  }),
  postWmsCycleCountLine: responseEndpoint<WmsCycleCountCountLineApiData, WmsCycleCountCountLineApiResponses>({
    getUrl: ({ cycleCountId }) => apiUrl(`wms/cycle-counts/${cycleCountId}/lines/`),
    getBody: ({ cycleCountId: _, ...body }) => body
  }),
  postWmsCycleCountComplete: responseEndpoint<WmsCycleCountCompleteApiData, WmsCycleCountCompleteApiResponses>({
    getUrl: ({ cycleCountId }) => apiUrl(`wms/cycle-counts/${cycleCountId}/complete/`)
  }),
  postWmsCycleCountCancel: responseEndpoint<WmsCycleCountCancelApiData, WmsCycleCountCancelApiResponses>({
    getUrl: ({ cycleCountId }) => apiUrl(`wms/cycle-counts/${cycleCountId}/cancel/`)
  }),
  getPaginatedWmsStockPolicies: dataEndpoint<WmsStockPolicyListApiData, WmsStockPolicyListApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/stock-policies/', queryParams)
  }),
  getWmsStockPolicy: dataEndpoint<WmsStockPolicyGetApiData, WmsStockPolicyGetApiResponses>({
    getUrl: ({ stockPolicyId }) => apiUrl(`wms/stock-policies/${stockPolicyId}/`)
  }),
  postWmsStockPolicy: responseEndpoint<WmsStockPolicyCreateApiData, WmsStockPolicyCreateApiResponses>({
    getUrl: () => apiUrl('wms/stock-policies/'),
    getBody: (data) => data
  }),
  patchWmsStockPolicy: responseEndpoint<WmsStockPolicyPatchApiData, WmsStockPolicyPatchApiResponses>({
    getUrl: ({ stockPolicyId }) => apiUrl(`wms/stock-policies/${stockPolicyId}/`),
    getBody: ({ stockPolicyId: _, ...body }) => body
  }),
  deleteWmsStockPolicy: dataEndpoint<WmsStockPolicyDeleteApiData, WmsStockPolicyDeleteApiResponses>({
    getUrl: ({ stockPolicyId }) => apiUrl(`wms/stock-policies/${stockPolicyId}/`)
  }),
  getWmsScan: dataEndpoint<WmsScanApiData, WmsScanApiResponses>({
    getUrl: (queryParams) => apiUrl('wms/scan/', queryParams)
  }),
  getPaginatedWmsOrganizationPolicies: dataEndpoint<
    WmsOrganizationPolicyListApiData,
    WmsOrganizationPolicyListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('wms/organization-policies/', queryParams)
  }),
  getWmsOrganizationPolicy: dataEndpoint<WmsOrganizationPolicyGetApiData, WmsOrganizationPolicyGetApiResponses>({
    getUrl: ({ organizationPolicyId }) => apiUrl(`wms/organization-policies/${organizationPolicyId}/`)
  }),
  postWmsOrganizationPolicy: responseEndpoint<
    WmsOrganizationPolicyCreateApiData,
    WmsOrganizationPolicyCreateApiResponses
  >({
    getUrl: () => apiUrl('wms/organization-policies/'),
    getBody: (data) => data
  }),
  patchWmsOrganizationPolicy: responseEndpoint<
    WmsOrganizationPolicyPatchApiData,
    WmsOrganizationPolicyPatchApiResponses
  >({
    getUrl: ({ organizationPolicyId }) => apiUrl(`wms/organization-policies/${organizationPolicyId}/`),
    getBody: ({ organizationPolicyId: _, ...body }) => body
  })
};
